const avatarBorderColor: object = {
  white: {
    borderColor: "border-white",
  },
  "blue-gray": {
    borderColor: "border-blue-gray-500",
  },
  gray: {
    borderColor: "border-gray-900",
  },
  brown: {
    borderColor: "border-brown-500",
  },
  "deep-orange": {
    borderColor: "border-deep-orange-500",
  },
  orange: {
    borderColor: "border-orange-500",
  },
  amber: {
    borderColor: "border-amber-500",
  },
  yellow: {
    borderColor: "border-yellow-500",
  },
  lime: {
    borderColor: "border-lime-500",
  },
  "light-green": {
    borderColor: "border-light-green-500",
  },
  green: {
    borderColor: "border-green-500",
  },
  teal: {
    borderColor: "border-teal-500",
  },
  cyan: {
    borderColor: "border-cyan-500",
  },
  "light-blue": {
    borderColor: "border-light-blue-500",
  },
  blue: {
    borderColor: "border-blue-500",
  },
  indigo: {
    borderColor: "border-indigo-500",
  },
  "deep-purple": {
    borderColor: "border-deep-purple-500",
  },
  purple: {
    borderColor: "border-purple-500",
  },
  pink: {
    borderColor: "border-pink-500",
  },
  red: {
    borderColor: "border-red-500",
  },
};

export default avatarBorderColor;
